/**
 * Reine IP-Klassifikation (KEINE node-/mmdb-Abhängigkeiten), damit sie sowohl
 * serverseitig (GeoIP-Provider) als auch im UI-Bundle (Player-Intel
 * Auto-Lookup) importiert werden kann.
 */

/** Lehnt private/reservierte/loopback/link-local Adressen ab (kein Public-Lookup). */
export function isPublicIp(ip: string): boolean {
  const s = ip.trim().toLowerCase();
  if (s === "" || s === "0" || s === "0.0.0.0" || s === "::" || s === "::1" || s === "localhost") return false;
  // IPv4
  const m = s.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
  if (m) {
    const o = m.slice(1, 5).map(Number);
    if (o.some((x) => x > 255)) return false;
    const [a, b] = o as [number, number, number, number];
    if (a === 10) return false;                          // 10.0.0.0/8
    if (a === 127) return false;                         // loopback
    if (a === 172 && b >= 16 && b <= 31) return false;   // 172.16.0.0/12
    if (a === 192 && b === 168) return false;            // 192.168.0.0/16
    if (a === 169 && b === 254) return false;            // link-local
    if (a === 100 && b >= 64 && b <= 127) return false;  // CGNAT 100.64.0.0/10
    if (a === 0) return false;
    if (a >= 224) return false;                          // multicast/reserved
    return true;
  }
  // IPv6 (grob): unique-local fc00::/7, link-local fe80::/10 ablehnen
  if (s.includes(":")) {
    if (s.startsWith("fe8") || s.startsWith("fe9") || s.startsWith("fea") || s.startsWith("feb")) return false;
    if (s.startsWith("fc") || s.startsWith("fd")) return false;
    return /^[0-9a-f:]{2,45}$/.test(s);
  }
  return false;
}
